export const fallbackLng = 'en'
export const languages = ['ja', 'en', 'ko', 'zh-Hans', 'zh-Hant']
export const cookieName = 'i18next'
export const defaultNS = 'common'

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  }
}
